//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../Mechatronics/Mechatronics.SelectDynamicMaterial.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"Category",1,0],[1,"CutOffset",0,"Expression",0],[0,"CutOption",1,0],[1,"CutterWidth",0,"Expression",0],[1,"CuttingTool",0,"SelectNXObject",0],[0,"Mode",1,0],[0,"Name",1,0],[1,"ObjectToCut",0,"Mechatronics.SelectDynamicMaterial",0],[0,"ResultCollisionType",1,0],[0,"ReverseDirection",1,0],[0,"TargetSourceType",1,0],[0,"UpdateCollision",1,0]],[],[]];
SPLM.Mechatronics.DynamicMaterialCutterBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.DynamicMaterialCutterBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.DynamicMaterialCutterBuilder.CutMode = Object.freeze({
    "BySize" : "BySize", "ByToolBody" : "ByToolBody"});

SPLM.Mechatronics.DynamicMaterialCutterBuilder.CutTarget = Object.freeze({
    "OnlySelected" : "OnlySelected", "BodyFromSensor" : "BodyFromSensor", "DetectByTooling" : "DetectByTooling"});

SPLM.Mechatronics.DynamicMaterialCutterBuilder.ResultCollision = Object.freeze({
    "Mesh" : "Mesh", "Convex" : "Convex"});

export default SPLM;